import { useContext } from 'react';
import { HeroSectionDataContext, HeroSectionMutatorContext } from './heroSectionContext';

export const useHeroSectionSelector = () => useContext(HeroSectionDataContext);
export const useHeroSectionMutator = () => useContext(HeroSectionMutatorContext);
